import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import BrowserUpgrade from './components/BrowserUpgrade';
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import reducers from './reducers';
import './styles/App.css';
const { detect } = require('detect-browser');
const browser = detect();

// import registerServiceWorker from './registerServiceWorker';

let store = createStore(reducers);

// if(browser.name === 'ie'){
//     ReactDOM.render(<BrowserUpgrade />, document.getElementById('root'));
// }else{
    ReactDOM.render(<Provider store={store}><App/></Provider>, document.getElementById('root'));
//}

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js